module.exports = __webpack_public_path__ + "img/how-work-4.8810ec56.png";